// Core card/RNG primitives. ENGINE_DESIGN.md §1 (core/cards.ts, core/rng.ts).
import { z } from 'zod';
/** 0..51. rank-major: index = rank * 4 + suit. rank 0=deuce..12=ace; suit 0=c,1=d,2=h,3=s.
 *  Branded so a raw number can't be passed where a CardIndex is required. */
export const CardIndexSchema = z.number().int().min(0).max(51).brand();
export const RankSchema = z.number().int().min(0).max(12);
export const SuitSchema = z.number().int().min(0).max(3);
/** "As", "Td" - string card form. Edges only (parse/format); never crosses to the coach. */
export const CardStringSchema = z.string().regex(/^[2-9TJQKA][cdhs]$/, 'expected a card string like "As" or "Td"');
/** length 0 | 3 | 4 | 5 (preflop / flop / turn / river). */
export const BoardSchema = z
    .array(CardIndexSchema)
    .refine((b) => b.length === 0 || b.length === 3 || b.length === 4 || b.length === 5, {
    message: 'Board length must be 0, 3, 4, or 5',
});
//# sourceMappingURL=primitives.js.map